import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { Card as NativeCard } from 'ui-components-web'
import { ThemeProvider } from '@material-ui/core/styles'

import cardOverride from 'theming/overrides/cards/card'
import { FC, ReactNode } from 'react'

type CardProps = {
  TitleIcon?: FC | null
  TitleButton?: ReactNode | null
  title?: string
  actions?: ReactNode
  children?: ReactNode
  className?: string
  titleClassName?: string
  contentClassName?: string
}

const Card = ({
  TitleIcon,
  TitleButton,
  title,
  actions,
  className,
  titleClassName,
  contentClassName,
  children,
}: CardProps) => {
  const isTitleBlockVisible = TitleIcon || TitleButton || title

  return (
    <ThemeProvider theme={cardOverride}>
      <NativeCard
        className={classNames(
          'overflow-hidden w-auto border border-current xl:max-w-[680px] [&_svg]:h-5 [&_svg]:mr-3',
          className,
        )}
      >
        {isTitleBlockVisible && (
          <div className={classNames('px-6 py-4 flex items-center justify-between', titleClassName)}>
            <div className="flex items-center">
              {!!TitleIcon && <TitleIcon aria-hidden="true" />}
              {title && (
                <h5 className="typography-body-xl text-[20px] font-medium typography-primary-800 tracking-tight">
                  {title}
                </h5>
              )}
            </div>
            {TitleButton}
          </div>
        )}

        <div className={classNames('mx-6 my-4 [&_svg]:h-[18px] [&_svg]:mr-3', contentClassName)}>
          {children}
          {actions ? <div className="mt-4 mb-6">{actions}</div> : null}
        </div>
      </NativeCard>
    </ThemeProvider>
  )
}

export default Card
